module.exports = __webpack_public_path__ + "static/media/hall-P2.9b949c01.svg";